import { QUALIFICATIONS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const FreeQualificationsService = {
  getAll: () => requests.get(`${QUALIFICATIONS_URL}/free-qualifications`),
  delete: (name: string) => requests.delete(`${QUALIFICATIONS_URL}/free-qualifications-delete`, { name }),
  approve: (name: string) => requests.put(`${QUALIFICATIONS_URL}/free-qualifications-approve`, { name }), // Add approve method
};